(() => {
  const ENABLE_LOGS = false;
  const log = (...a) => ENABLE_LOGS && console.log('[subi]', ...a);

  const ROOT   = '.subify-widget-whole-wrapper.skin-3';
  const LIST   = '.subify-selling-plan-list';
  const COL    = '.subify-selling-plan-col';
  const ITEM   = '.subify-selling-plan-item';
  const OTP_ID = '#subify-widget-one-time-purchase-text';
  const BENEFITS_CLASS = 'alljana-benefits';
  const MOUNT_FLAG = 'data-alljana-mounted';

  const BENEFITS = [
    '30-day money back guarantee',
    'Cancel or pause anytime',
    'Free Shipping to US',
  ];

  function findRoot()   { return document.querySelector(ROOT); }
  function getCols(r)   { return r ? Array.from(r.querySelector(LIST)?.querySelectorAll(COL) || []) : []; }
  function findSubItem(r){
    for (const col of getCols(r)) {
      const item = col.querySelector(ITEM);
      if (item && !col.querySelector(OTP_ID)) return item; // exclude One-Time
    }
    return null;
  }

  function buildBenefits() {
    const wrap = document.createElement('div');
    wrap.className = BENEFITS_CLASS;
    wrap.innerHTML = `
      <ul class="alljana-checks" role="list">
        ${BENEFITS.map(t => `<li>${t}</li>`).join('')}
      </ul>
    `;
    return wrap;
  }

  function mount() {
    const root = findRoot();
    if (!root) return;

    const subItem = findSubItem(root);
    if (!subItem) { log('subscription item not found yet'); return; }

    if (subItem.hasAttribute(MOUNT_FLAG) || subItem.querySelector('.' + BENEFITS_CLASS)) {
      return; // already there
    }

    // Inject INSIDE the item so it stays part of the card, but below the row
    subItem.appendChild(buildBenefits());
    subItem.setAttribute(MOUNT_FLAG, '1');
    log('benefits injected inside subscription item');
  }

  function start() {
    const mo = new MutationObserver(() => { try { mount(); } catch(e){ console.error(e); } });
    mo.observe(document.body, { childList: true, subtree: true });
    mount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();